import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'militaryTime',
    standalone: true
})
export class MilitaryTimePipe implements PipeTransform {
  transform(time: string, militaryTime: boolean = false): string {
    if (militaryTime) return time
    let [ hours, minutes ] = time.split(":").map(t => +t)
    const m = hours > 11 ? 'p.m.' : 'a.m.'
    hours = (hours % 12) || 12 
    const timeString = `${hours}:${minutes < 10 ? '0' : ''}${minutes} ${m}`
    return timeString
  }
}
